import React, { useEffect, useState } from "react";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { Drawer, Button, Menu, Layout } from "antd";
import {
  MenuOutlined,
  LogoutOutlined,
  DashboardOutlined,
  FileTextOutlined,
  CheckCircleOutlined,
  CommentOutlined,
} from "@ant-design/icons";

const { Sider } = Layout;

function isWebView() {
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;
  // Android web view tespiti
  if (/wv|Android.*Chrome\/[.0-9]* Mobile/.test(userAgent)) {
    return true;
  }
  // iOS web view tespiti
  if (/iPhone|iPod|iPad.*AppleWebKit(?!.*Safari)/.test(userAgent)) {
    return true;
  }
  return false;
}

const Header = () => {
  const [visible, setVisible] = useState(false); // Drawer görünürlük durumu
  const [isMobile, setIsMobile] = useState(false); // Mobil kontrol
  const navigate = useNavigate();
  const location = useLocation();
  const isMobileWebView = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

  const [searchParams] = useSearchParams();
  const accessToken = searchParams.get("accessToken");
  const userInfo = searchParams.get("user");
  const clientId = searchParams.get("Client-Id");
  const oneId = searchParams.get("One-Id");
  const isDoctor = searchParams.get("isDoctor");

  const parseUser = () => {
    try {
      return userInfo ? JSON.parse(userInfo) : null;
    } catch (error) {
      return null;
    }
  };

  const user = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user"))
    : parseUser();

  useEffect(() => {
    if (accessToken && user) {
      localStorage.setItem("accessToken", accessToken);
      localStorage.setItem("clientId", clientId);
      localStorage.setItem("oneId", oneId);
      localStorage.setItem("user", JSON.stringify(user));

      // Kullanıcı tipine göre IsDoctor ve IsNurse ayarı
      if (isDoctor === "true" || user?.isDoctor) {
        localStorage.setItem("IsDoctor", true);
        navigate("/dashboard");
      } else if (user?.isPatient) {
        localStorage.setItem("IsDoctor", false);
        navigate("/select-facility");
      } else if (user?.isNurse) {
        localStorage.setItem("IsNurse", true);
        navigate("/nurse-dashboard");
      } else {
        navigate("/patient-register");
      }
    }
  }, [accessToken, clientId, oneId, user, isDoctor, navigate]);

  useEffect(() => {
    if (!user) {
      localStorage.clear();
      navigate("/login");
    } else if (
      !localStorage.getItem("IsDoctor") &&
      !localStorage.getItem("IsNurse") &&
      !user.isPatient
    ) {
      navigate("/patient-register");
    }

    // Ekran genişliği değişimini takip et
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize(); // İlk yüklemede durumu kontrol et
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [user, navigate]);

  const handleLogout = () => {
    localStorage.clear();
    navigate("/login");
    window.location.reload();
  };

  const showDrawer = () => {
    setVisible(true);
  };

  const closeDrawer = () => {
    setVisible(false);
  };

  const IsDoctor = localStorage.getItem("IsDoctor") === "true";
  const IsNurse = localStorage.getItem("IsNurse") === "true";

  const menuItems = [
    IsNurse
      ? {
          key: "/nurse-dashboard",
          icon: <DashboardOutlined />,
          label: "Nurse Dashboard",
          onClick: () => navigate("/nurse-dashboard"),
        }
      : IsDoctor
      ? {
          key: "/dashboard",
          icon: <DashboardOutlined />,
          label: "Doctor Dashboard",
          onClick: () => navigate("/dashboard"),
        }
      : {
          key: "/select-facility",
          icon: <FileTextOutlined />,
          label: "Yeni Başvuru",
          onClick: () => {
            navigate("/select-facility");
            window.location.reload();
          },
        },
    !IsNurse &&
      !IsDoctor && {
        key: "/applications",
        icon: <FileTextOutlined />,
        label: "Başvurularım",
        onClick: () => navigate("/applications"),
      },
    !IsNurse &&
      !IsDoctor && {
        key: "/application-results",
        icon: <CheckCircleOutlined />,
        label: "Sonuçlarım",
        onClick: () => navigate("/application-results"),
      },
    !IsNurse &&
      !IsDoctor && {
        key: "/requests-and-suggestions",
        icon: <CommentOutlined />,
        label: "İstek ve Önerileriniz",
        onClick: () => navigate("/requests-and-suggestions"),
      },
  ].filter(Boolean);

  return (
    <Layout>
      {isMobile && (
        <Layout.Header
          style={{
            backgroundColor: "#09C35C",
            color: "#fff",
            padding: "0 20px",
            display: "flex",
            alignItems: "center",
          }}
        >
          <Button
            type="primary"
            icon={<MenuOutlined />}
            onClick={showDrawer}
            style={{ marginRight: 16 }}
            className="bg-gray-100 text-[#09C35C]"
          />
        </Layout.Header>
      )}

      {!isMobile ? (
        // Masaüstü görünümü
        <Sider
          width={250}
          style={{
            background: "#fff",
            height: "100vh",
            position: "fixed",
            border: "1px solid #ddd",
            boxShadow: "2px 0 5px rgba(0, 0, 0, 0.1)",
            left: 0,
            top: 0,
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              padding: "16px",
              textAlign: "center",
              borderBottom: "1px solid #ddd",
            }}
          >
            <img
              src="/assets/images/onedose_black.png.webp" // Logonuzun dosya yolu
              alt="Logo"
              style={{ height: "35px" }}
            />
          </div>
          <Menu
            mode="inline"
            selectedKeys={[location.pathname]}
            style={{ height: "calc(100% - 60px)", borderRight: 0 }} // Logout için boşluk bırak
            items={menuItems}
          />
          <div
            style={{
              position: "absolute",
              bottom: 50,
              width: "100%",
              borderTop: "1px solid #ddd",
              padding: "10px",
              textAlign: "end",
            }}
          >
            <p className="mb-2">
              {user?.name + " " + user?.lastName}
            </p>
            {!isWebView() && (
              <Button
                type="text"
                icon={<LogoutOutlined />}
                onClick={handleLogout}
                style={{ width: "100%" }}
                className="flex justify-end"
              >
                Çıkış Yap
              </Button>
            )}
          </div>
        </Sider>
      ) : (
        // Mobil görünümü
        <Drawer
          title={
            <img
              src="/assets/images/onedose_black.png.webp"
              alt="Logo"
              style={{ height: "30px" }}
            />
          }
          placement="left"
          onClose={closeDrawer}
          open={visible}
          bodyStyle={{ padding: 0 }}
        >
          <Menu
            mode="inline"
            selectedKeys={[location.pathname]}
            items={menuItems}
            style={{ paddingBottom: "60px" }} // Logout için boşluk bırak
          />
          <div
            style={{
              position: "absolute",
              bottom: 50,
              width: "100%",
              borderTop: "1px solid #ddd",
              padding: "10px",
              textAlign: "end",
            }}
          >
            <p className="mb-2">
              {user?.name + " " + user?.lastName}
            </p>
            {!isWebView() && (
              <Button
                type="text"
                icon={<LogoutOutlined />}
                onClick={handleLogout}
                style={{ width: "100%" }}
                className="flex justify-end"
              >
                Çıkış Yap
              </Button>
            )}
          </div>
        </Drawer>
      )}
    </Layout>
  );
};

export default Header;
